import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppContext } from '../../context/AppProvider'
import { removeFromFeaturedShop, setToFeaturedShop } from '../../redux/actions'
import { StoreState } from '../../redux/reducers'
import { Shop } from '../../redux/reducers/shop.reducer'
import { AppDispatch } from '../../redux/store'
import Switch from '../utils/Switch'

export interface ShopMoreDetailsProps {
    onClose?: () => void
    id: string | null
}

const ShopMoreDetails = (props: ShopMoreDetailsProps) => {
    const dispatch = useDispatch<AppDispatch>()

    const appProvider = React.useContext(AppContext)
    const shop = useSelector<StoreState, Shop | null>(state => state.shops.find(shop => shop.id === props.id) || null)

    const featuredClickHandler = () => {
        if (shop) {
            appProvider?.showOverlay?.()
            if (shop.featured) {
                dispatch(removeFromFeaturedShop(shop.id)).finally(() => {
                    appProvider?.hideOverlay?.()
                })
            } else {
                dispatch(setToFeaturedShop(shop.id)).finally(() => {
                    appProvider?.hideOverlay?.()
                })
            }
        }
    }
    return (<div>
        <Switch checked={shop?.featured} onClick={featuredClickHandler} />
    </div>)
}

export default ShopMoreDetails